
; (function () {
    angular.module("EMR.ProgramServiceCustomPopup", []);


    var ProgramServiceCustomPopup = [
        {
            "name": "ProgramServiceCustomPopup",
            "templateUrl": "<div emr-common-program-service-custom-popup></div>",
            "RoutingNumber": 2829,
            files: [
                "AngularScripts/ProgramServiceCustomPopup/Services/CommonProgramServiceCustomPopupService.js",
                "AngularScripts/ProgramServiceCustomPopup/Directives/CommonProgramServiceCustomPopupDirective.js",
            ]
        }
    ];

    angular.module('EMR.ProgramServiceCustomPopup')
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(ProgramServiceCustomPopup, $stateProvider);
            }]);
})();